import { apiRequest } from './apiService';

export const fetchInventoryProducts = async () => {
  return await apiRequest('/inventory/inventory-products', 'GET');
};

export const createInventoryProduct = async (productData: any) => {
  return await apiRequest('/inventory/inventory-products', 'POST', productData);
};

export const updateInventoryProduct = async (
  productId: string,
  productData: any
) => {
  return await apiRequest(
    `/inventory/inventory-products/${productId}`,
    'PUT',
    productData
  );
};

export const deleteInventoryProduct = async (productId: string) => {
  return await apiRequest(
    `/inventory/inventory-products/${productId}`,
    'DELETE'
  );
};

export const fetchInventoryProductById = async (productId: string) => {
  return await apiRequest(`/inventory/inventory-products/${productId}`, 'GET');
};
